'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Children = exports.createChildren = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var safeClone = function safeClone(child, props) {
  return child && typeof child.type === 'function' ? _react2.default.cloneElement(child, props) : child;
};

var cloneChildren = function cloneChildren(children, props) {
  return _react2.default.createElement('span', null, _react2.default.Children.map(children, function (child) {
    return safeClone(child, props);
  }));
};

var createChildren = function createChildren(components, props) {
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (components[index]) {
    return _react2.default.createElement(components[index], props, createChildren(components, props, index + 1));
  } else {
    var children = props.children,
        rest = _objectWithoutProperties(props, ['children']);

    return children && _react2.default.Children.count(children) > 1 ? cloneChildren(children, rest) : safeClone(children, rest);
  }
};

exports.createChildren = createChildren;

var Children = function Children(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ['children']); // eslint-disable-line


  return children && typeof children.type === 'function' ? _react2.default.cloneElement(children, props) : children;
};

exports.Children = Children;